import * as React from "react"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { makeStyles } from "tss-react/mui"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLinkHorizontal } from "@fortawesome/pro-light-svg-icons"
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { MERCHANT_ACCOUNTING_ORDERS } from "../../../../../constants/routes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

type StyleProps = Readonly<{
    open: boolean
}>

const useStyles = makeStyles<StyleProps>()((theme, { open }) => ({
    menuButton: {
        padding: "0.75rem 1rem !important",
        border: `1px solid ${theme.palette.divider}`,
        width: "fit-content",
        backgroundColor: "white",
        gap: theme.spacing(1),
        height: "2.5rem",
        borderRadius: "0.75rem !important",
        color: theme.palette.tailwind.slate[800],
    },
    dropDownIcon: {
        transition: "transform 0.3s ease",
        color: theme.palette.tailwind.slate[500],
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
    },
    menu: {
        minWidth: "9rem",
        boxShadow: "-1px 3px 10px 0 rgba(0, 0, 0, 0.14)",
    },
}))

export default function Shortcuts() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const { classes } = useStyles({ open })
    const navigate = useNavigate()

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)
    const onBookedOrdersClick = () => {
        navigate(`${MERCHANT_ACCOUNTING_ORDERS}?tab=0`)
        handleClose()
    }

    return (
        <div>
            <StandardButton className={classes.menuButton} onClick={handleClick} variant="outlined">
                <FontAwesomeIcon icon={faLinkHorizontal} size="sm" />
                Shortcuts
                <FontAwesomeIcon icon={faCaretDown} size="sm" className={classes.dropDownIcon} />
            </StandardButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{ paper: { className: classes.menu } }}
            >
                <MenuItem onClick={onBookedOrdersClick}>
                    <LocalizedStrict id="production-meeting-service-shortcut-booked-orders">
                        <>Booked orders</>
                    </LocalizedStrict>{" "}
                </MenuItem>
            </Menu>
        </div>
    )
}
